import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Global skeleton theme provider that configures react-loading-skeleton
 * with the app's design tokens for consistent shimmer animations.
 *
 * Wrap your app with this provider to ensure all Skeleton components
 * from react-loading-skeleton use consistent styling.
 */
export function SkeletonThemeProvider({
  children,
}: SkeletonThemeProviderProps) {
  return (
    <SkeletonTheme
      baseColor='var(--accent)'
      highlightColor='var(--background)'
      borderRadius='0.375rem'
    >
      {children}
    </SkeletonTheme>
  );
}
